import React from 'react'
import PropTypes from 'prop-types'

import {
  Heading,
  SvgIcon,
  PageNavigationButtons
} from '../'

// Component can either be initialised with using 'columns' & 'rows' props
// <CardTable
//   heading='My Tasks'
//   headingIcon='groups'
//   columns={['step', 'assigned to', 'scheduled at', 'completed at', 'actions']}
//   rows={[{id: '123', step: '1', assignedTo: 'john', scheduledAt: 'tomorrow', completedAt: ', actions: '}]} />
// OR by passing in table header/row components as objects
// <CardTable
//   heading='My Tasks'
//   headingIcon='groups'
//   tableColumnHeader={<TableHeaderRow />}  // component
//   tableDataRows={rows}   // where rows is an array of row components
// />
// OR combination for the above

export default class CardTable extends React.Component {
  static propTypes = {
    heading: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),
    headingIcon: PropTypes.string,  // one of https://www.lightningdesignsystem.com/icons/#standard
    columns: PropTypes.arrayOf(PropTypes.string),
    rows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object)),
    tableColumnHeader: PropTypes.element,  // instance of TableHeaderRow
    tableDataRows: PropTypes.arrayOf(PropTypes.element),
    navigationButtons: PropTypes.bool,
    onNextClick: PropTypes.func,
    onPreviousClick: PropTypes.func,
    previousDisabled: PropTypes.bool,
    nextDisabled: PropTypes.bool,
    startCursor: PropTypes.string,
    totalCount: PropTypes.number,
    resultsPerPage: PropTypes.number,
    onPageNumberClick: PropTypes.func
  }

  static defaultProps = {
    navigationButtons: true
  }

  generateTableHeaderRow = (columns) => {
    let headerRow = columns.map((columnHeader, i) => (
      <TableColumnHeader header={columnHeader} key={i} title={columnHeader} />
    ))

    return headerRow
  }

  generateTableDataRows = (dataRows) => {
    let rows = dataRows.map((row, i) => (
      <TableDataRow data={row} key={i} />
    ))

    return rows
  }

  render() {
    let columns = this.props.tableColumnHeader
      ? this.props.tableColumnHeader
      : this.generateTableHeaderRow(this.props.columns)
    let rows = this.props.tableDataRows
      ? this.props.tableDataRows
      : this.generateTableDataRows(this.props.rows)

    return (
      <article className='slds-card slds-m-bottom_large slds-scrollable'>
        {(this.props.heading || this.props.actionButtons) &&
          <div className='slds-card__header slds-grid'>
            <header className='slds-media slds-media_center slds-has-flexi-truncate'>
              {this.props.headingIcon
                ? <div className='slds-media__figure'>
                    <span className='slds-icon_container slds-icon-text-default' title='Clients'>
                      <SvgIcon
                        variant='standard'
                        symbol={this.props.headingIcon}
                      />
                    </span>
                  </div>
                : null
              }
              {this.props.heading &&
                <div className='slds-media__body'>
                  <Heading>
                    {this.props.heading}
                  </Heading>
                </div>
              }
              <div className='slds-col_bump-left slds-grid'>
                {this.props.actionButtons &&
                  <div className='slds-p-right_medium'>
                    {this.props.actionButtons}
                  </div>
                }
              </div>
            </header>
          </div>
        }
        <div className='slds-card__body'>
          <table className={`slds-table slds-table_bordered ${this.props.fixedLayout ? 'slds-table_fixed-layout' : ''}`} role='grid'>
            <thead>
              {this.props.tableColumnHeader
                ? columns
                : <tr className='slds-line-height_reset slds-theme_shade'>
                    {columns}
                  </tr>
              }
            </thead>
            <tbody>
              {rows.length === 0
                ? <tr>
                    <td colSpan={7}>
                      <div className='slds-p-left_x-large'>
                        {this.props.noRecordsMessage || 'No records to display.'}
                      </div>
                    </td>
                  </tr>
                : rows
              }
            </tbody>
          </table>
        </div>
        <div className='slds-card__footer slds-clearfix'>
          {this.props.navigationButtons &&
            <PageNavigationButtons
              onNextClick={this.props.nextPage}
              onPreviousClick={this.props.previousPage}
              previousDisabled={this.props.onFirstPage}
              nextDisabled={this.props.onLastPage}
              startCursor={this.props.startCursor}
              totalCount={this.props.totalCount}
              resultsPerPage={this.props.resultsPerPage}
              onPageNumberClick={this.props.onPageNumberClick}
            />
          }
        </div>
      </article>
    )
  }
}

class TableColumnHeader extends React.Component {
  render() {
    return (
      <th className='slds-text-title_caps' scope='col'>
        <span className='slds-truncate slds-th__action' title={this.props.header}>{this.props.header}</span>
      </th>
    )
  }
}

class TableDataRow extends React.Component {
  render() {
    let row = this.props.data

    return (
      <tr className='slds-hint-parent' aria-selected='true'>
        <th scope='row'>
          <div className='slds-truncate' title={row.step}>
            {row.step}
          </div>
        </th>
        <td role='gridcell'>
          <div className='slds-truncate' title={row.assignedTo}>
            {row.assignedTo}
          </div>
        </td>
        <td role='gridcell'>
          <div className='slds-truncate' title={row.scheduledAt}>
            {row.scheduledAt}
          </div>
        </td>
        <td role='gridcell'>
          <div className='slds-truncate' title={row.completedAt}>
            {row.completedAt}
          </div>
        </td>
        <td role='gridcell'>
          <div className='slds-truncate' title={row.actions}>
            {row.actions}
          </div>
        </td>
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/card-table/index.js